module.exports = __webpack_public_path__ + "static/media/date-pier.28781447.png";